export const ConfigMantenedorPerfiles = {
   barraBusqueda: {
      criterios: ["Nombre"],
      criteriosKeys: ["nombre"],
      criterioPrincipal: "Nombre",
   },
   table: {
      title: "Perfiles",
      add: "Agregar Perfil",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};
